import type { ReactElement } from 'react'

import FormikValue from './FormikValue'

export default function FormikRangeInputField({
  name,
  disabled = false,
  min = 0,
  max = 100,
  step = 1,
  ...inputProps
}): ReactElement {
  return (
    <FormikValue name={name}>
      {(value, setValue) => {
        const rangeFieldStyle = {
          '--min': min,
          '--max': max,
          '--val': value,
        }

        return (
          <div className="dali-range-input-with-numeric">
            <input
              type="range"
              style={rangeFieldStyle}
              className="dali-range-input"
              min={min}
              name={name}
              max={max}
              step={step}
              disabled={disabled}
              value={value}
              onChange={(e) => setValue(Number(e.target.value))}
              {...inputProps}
            />
            <input
              type="number"
              className="dali-range-output"
              min={min}
              name={name}
              max={max}
              step={step}
              disabled={disabled}
              value={value}
              onChange={(e) => setValue(Number(e.target.value))}
              {...inputProps}
            />
          </div>
        )
      }}
    </FormikValue>
  )
}
